import { Api } from "@/core/api.js";
const api = new Api();

// initial state
const state = {
  list: [],
  total_list: 0,
  isUploading: false,
  pagination: { num_page: 1, num_items: -1 },
  current_filters: {},
  bFirstTime: true,
  list_by_category: [],
  match: null
};

// getters
const getters = {
  getList: (state, getters, rootState, rootGetters) => id => {
    var aMatchs = [];
    var tmplteams = rootGetters["competition/getListTmplTeams"]();
    var categories = rootGetters["events/getCurrentEvent"]().categories;
    var rounds = rootGetters["competition/getListRounds"]();
    var phases = rootGetters["competition/getListPhases"]();
    var groups = rootState.competition.groups.list;
    var facilities = rootState.facilitys.list;

    if (typeof id !== "undefined" && state.list[id] !== "undefined") {
      var match = Object.assign({}, state.list[id].info);
      var round = rounds[match.round_id];
      match.status = parseInt(match.status);
      match.category =
        round.phase_id != null
          ? categories[phases[round.phase_id].category_id].max_age
          : categories[phases[groups[round.group_id].phase_id].category_id]
              .max_age;
      match.group =
        round.phase_id != null
          ? phases[round.phase_id].name
          : groups[round.group_id].name;
      match.round = round.name;
      match.local_team = state.list[id].teams[match.local_team_id];
      match.away_team = state.list[id].teams[match.away_team_id];
      match.facility =
        facilities[match.facility_id] != undefined
          ? facilities[match.facility_id].name_competition
          : null;

      match.log = state.list[id].log;

      //SETTING WINNER
      if (match.status == 9) {
        if (parseInt(match.local_goals) > parseInt(match.away_goals)) {
          match.local_team.winner = true;
          match.away_team.winner = false;
        } else if (parseInt(match.local_goals) < parseInt(match.away_goals)) {
          match.local_team.winner = false;
          match.away_team.winner = true;
        } else {
          if (
            parseInt(match.local_penalti_goals) >
            parseInt(match.away_penalti_goals)
          ) {
            match.local_team.winner = true;
            match.away_team.winner = false;
          } else if (
            parseInt(match.local_penalti_goals) <
            parseInt(match.away_penalti_goals)
          ) {
            match.local_team.winner = false;
            match.away_team.winner = true;
          } else {
            match.local_team.winner = false;
            match.away_team.winner = false;
          }
        }
      }

      return match;
    } else {
      for (var i in state.list) {
        if (state.list[i].visible) {
          var match = state.list[i];
          var round = rounds[match.round_id];

          //   console.log("groups[round.group_id]", groups[round.group_id]);
          //   console.log(phases, groups, round.group_id);
          //   console.log(
          //     "phases[groups[round.group_id].phase_id]",
          //     phases[groups[round.group_id].phase_id]
          //   );

          match.category =
            round.phase_id != null
              ? categories[phases[round.phase_id].category_id].max_age
              : categories[phases[groups[round.group_id].phase_id].category_id]
                  .max_age;
          match.group =
            round.phase_id != null
              ? phases[round.phase_id].name
              : groups[round.group_id].name;
          match.round = round.name;
          match.local_team = tmplteams[match.local_team_id];
          match.away_team = tmplteams[match.away_team_id];

          //SETTING WINNER
          if (match.status == 9) {
            if (parseInt(match.local_goals) > parseInt(match.away_goals)) {
              match.local_team.winner = true;
              match.away_team.winner = false;
            } else if (
              parseInt(match.local_goals) < parseInt(match.away_goals)
            ) {
              match.local_team.winner = false;
              match.away_team.winner = true;
            } else {
              if (
                parseInt(match.local_penalti_goals) >
                parseInt(match.away_penalti_goals)
              ) {
                match.local_team.winner = true;
                match.away_team.winner = false;
              } else if (
                parseInt(match.local_penalti_goals) <
                parseInt(match.away_penalti_goals)
              ) {
                match.local_team.winner = false;
                match.away_team.winner = true;
              } else {
                match.local_team.winner = false;
                match.away_team.winner = false;
              }
            }
          }

          match.facility =
            facilities[match.facility_id] != undefined
              ? facilities[match.facility_id].name_competition
              : null;
          aMatchs.push(match);
        }
      }
      return aMatchs;
    }
  },

  getListNoFiltered: (state, getters, rootState) => type => {
    var aClubs = [];
    for (var i in state.list) {
      if (state.list[i].visible) aClubs.push(state.list[i]);
    }
    return aClubs;
  },

  getTotalList: (state, getters, rootState) => () => {
    return state.total_list;
  },

  getStatusMatch: (state, getters, rootState) => () => {
    var aStatus = [];
    for (var i = 1; i <= 9; i++) {
      aStatus.push({
        id: i,
        name: getters.statusToString(i)
      });
    }

    return aStatus;
  },

  statusToString: state => status => {
    switch (status) {
      case 1:
        return "miccamps.status.no_started";
        break;
      case 2:
        return "miccamps.status.uniforms";
        break;
      case 3:
        return "miccamps.status.players";
        break;
      case 4:
        return "miccamps.status.first_half";
        break;
      case 5:
        return "miccamps.status.half_time";
        break;
      case 6:
        return "miccamps.status.second_half";
        break;
      case 7:
        return "miccamps.status.penalties";
        break;
      case 8:
        return "miccamps.status.end";
        break;
      case 9:
        return "miccamps.status.closed";
        break;
      default:
        break;
    }
  },

  getMatchesByCategory: (state) => () => {
    return state.list_by_category
  },

  getFoundMatch: (state) => () => {
    return state.match
  }
};

// actions
const actions = {
  loadList({ commit, dispatch, getters, rootState, state }, params) {
    if (state.bFirstTime) {
      return dispatch("competition/loadPhases", params, { root: true }).then(
        function(response) {
          //   console.log(rootState);
          return dispatch(
            "teams/loadList",
            {
              event: rootState.events.current_event.id,
              page_options: { num_items: -1, page: -1 },
              filters: { status: 6 }
            },
            { root: true }
          ).then(function() {
            return dispatch("competition/loadTemplTeams", params, {
              root: true
            }).then(function() {
              return dispatch("competition/loadRounds", params, {
                root: true
              }).then(function() {
                return dispatch(
                  "facilitys/loadList",
                  {
                    event: rootState.events.current_event.id,
                    page_options: { num_items: -1, page: -1 }
                  },
                  {
                    root: true
                  }
                ).then(function() {
                  var oParams = Object.assign(
                    { page_options: { num_page: 0, num_items: -1 } },
                    params
                  );
                  return dispatch("competition/groups/loadList", oParams, {
                    root: true
                  }).then(function() {
                    var path = "competition/match/event/" + params.event;
                    var page_options = { num_page: 1, num_items: -1 };
                    var filters =
                      params && params.filters
                        ? params.filters
                        : state.current_filters;
                    var oParams = Object.assign(
                      filters ? filters : {},
                      page_options
                    );
                    if (params.phase_id) oParams.phase_id = params.phase_id;
                    if (params.category_id)
                      oParams.category_id = params.category_id;
                    return api.post(path, oParams).then(function(response) {
                      if (response.status) {
                        var data = response.data.data;
                        for (var i in data) {
                          data[i].visible = true;
                        }

                        commit("setList", {
                          data: data,
                          total: response.data.total
                        });
                        commit("setFirstTime", false);
                        return commit("setPagination", page_options);
                      }
                    });
                  });
                });
              });
            });
          });
        }
      );
    } else {
      var path = "competition/match/event/" + params.event;
      var page_options = { num_page: 1, num_items: -1 };
      var filters = params.filters ? params.filters : state.current_filters;
      var oParams = Object.assign(filters ? filters : {}, page_options);
      if (params.phase_id) oParams.phase_id = params.phase_id;
      return api.post(path, oParams).then(function(response) {
        if (response.status) {
          var data = response.data.data;
          for (var i in data) {
            data[i].visible = true;
          }

          commit("setList", {
            data: data,
            total: response.data.total
          });
          return commit("setPagination", page_options);
        }
      });
    }
  },

  load_by_id({ commit, dispatch, getters, rootState }, params) {
    if (rootState.competition.phases.length == 0) {
      return dispatch("competition/loadPhases", params, { root: true }).then(
        function(response) {
          return dispatch(
            "teams/loadList",
            {
              event: rootState.events.current_event.id,
              page_options: { num_items: -1, page: -1 },
              filters: { status: 6 }
            },
            { root: true }
          ).then(function() {
            return dispatch("competition/loadTemplTeams", params, {
              root: true
            }).then(function() {
              return dispatch(
                "competition/groups/loadList",
                {
                  event: rootState.events.current_event.id,
                  page_options: { num_items: -1, page: -1 }
                },
                {
                  root: true
                }
              ).then(function() {
                return dispatch("competition/loadRounds", params, {
                  root: true
                }).then(function() {
                  return dispatch(
                    "facilitys/loadList",
                    {
                      event: rootState.events.current_event.id,
                      page_options: { num_items: -1, page: -1 }
                    },
                    {
                      root: true
                    }
                  ).then(function() {
                    var path = "competition/match/" + params.id;
                    return api.get(path).then(function(response) {
                      if (response.status) {
                        var data = response.data;

                        return commit("addMatch", data);
                      }
                    });
                  });
                });
              });
            });
          });
        }
      );
    } else {
      var path = "competition/match/" + params.id;
      return api.get(path).then(function(response) {
        if (response.status) {
          var data = response.data;

          return commit("addMatch", data);
        }
      });
    }
  },

  editMatch({ commit, dispatch, getters, rootState }, params) {
    return api
      .post("competition/match/" + params.id + "/update", params.data)
      .then(function(response) {
        if (response.status) {
          var data = response.data;

          commit("addMatch", data);
          return dispatch("competition/loadTemplTeams", {}, { root: true });
        }
      });
  },

  load_by_name(context, params) {
    return api.post("competition/match/event/" + params.event_id + "/name/" + params.name, {category_id: params.category_id}).then(function(response) {
        if (response.status) {
            var data = response.data;
            data.visible = true
            return context.commit("addMatch", data);
        }
    });
  },

  load_by_category (context, params) {
    return api.post('competition/matches/event/' + params.event_id, { category_id: params.category_id }).then(
      function (response) {
        if (response.status) {
          var data = response.data
          data.visible = true
          context.commit("addMatchByCategory", data);
        }
      })
  },

  find_by_id ({ commit }, id) {
    var path = 'competition/match/' + id
    return api.get(path).then(function (response) {
      if (response.status) {
        var data = response.data
        return commit('saveMatch', data)
      }
    })
  }
};

// mutations
const mutations = {
  setList(state, data) {
    state.list = data.data;
    state.total_list = data.total;
  },

  addMatch(state, match) {
    var list = { ...state.list };
    list[match.id] = match;

    state.list = list;
  },

  saveMatch (state, match) {
    state.match = match
  },

  applyFilters(state, filters) {
    // console.log( "--- CLUBS APPLY FILTERS ---", filters )
    // var list = { ...state.list };
    // if (!filters) {
    //   for (var i in list) {
    //     list[i].visible = true;
    //   }
    // } else {
    //   for (var i in list) {
    //     list[i].visible = false;
    //   }
    //   for (var i in list) {
    //     var item = list[i];
    //     // console.log( " ---- ITEM " + item.name + " --- " );
    //     var bFound = true;
    //     for (var k in filters) {
    //       // console.log( "--- KEY: " + k + " ---" )
    //       if (filters[k] != -1) {
    //         var item_value =
    //           item[k] != null && typeof item[k] == "object"
    //             ? item[k].id
    //             : item[k];
    //         if (
    //           item.hasOwnProperty(k) &&
    //           filters[k] == null &&
    //           item_value == null
    //         ) {
    //         } else {
    //           // console.log( "KEY SEARCH: " + k + " ITEM: " + item_value + " - FILTER: " + filters[k] + " " + typeof filters[k] );
    //           // filters[k] = filters[k] == null ? null : ( typeof filters[k] !== 'string' ? ( typeof filters[k] !== 'boolean' ? ( filters[k] ? 1 : 0 ) : filters[k] ) : filters[k].trim() )

    //           if (filters[k] != null && typeof filters[k] === "boolean")
    //             filters[k] = filters[k] ? 1 : 0;
    //           else if (filters[k] != null && typeof filters[k] === "string")
    //             filters[k] = filters[k].trim();

    //           // console.log( "KEY SEARCH: " + k + " ITEM: " + item_value + " - FILTER: " + filters[k] + " " + typeof filters[k] );
    //           var regexp = new RegExp(filters[k], "gi");

    //           if (
    //             item.hasOwnProperty(k) &&
    //             typeof item[k] == "object" &&
    //             filters[k] != item_value
    //           ) {
    //             bFound = false;
    //           } else if (
    //             item.hasOwnProperty(k) &&
    //             typeof item[k] !== "object" &&
    //             !item_value.match(regexp)
    //           ) {
    //             bFound = false;
    //           }
    //         }
    //       }
    //     }

    //     list[i].visible = bFound;
    //   }
    // }

    // state.list = list;
    state.current_filters = filters;
  },
  setPagination(state, value) {
    state.pagination = value;
  },
  setFirstTime(state, value) {
    state.bFirstTime = value;
  },

  addMatchByCategory(state, matchesObject) {
    // Convert the object of matches to an array
    state.list_by_category = Object.values(matchesObject);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
